import React from 'react'
import DatePicker from 'react-datepicker';
import { CalenderIcon } from '../../../../components/Icon'
import { ButtonDropdown, DropdownMenu, DropdownToggle, Label } from 'reactstrap';
import moment from 'moment';
import { CloseIcon, DownDropArrow, FilterIcon } from '../../../../assets/images';
import Select from 'react-select';
import { CircularAvatar, RadioContainer, ToggleSwitch } from '../../../../components/commons';
import { RadioTypes } from '../../../../commonTypes/universalTypes';
import { components } from 'react-select';
import { DropDownType } from '../../../../commonTypes/clientDirectoryTypes';
import { SelectType } from '../../../../commonTypes/jobsType';

type DropDownOptionType = {
    value: number | null,
    label: string
}

const RADIO_OPTIONS: RadioTypes[] = [
    {
        id: "Open",
        _id:"Open",
        name: "Open"
    },
    {
        id: "Closed",
        _id:"Closed",
        name: "Closed"
    },
]

type AppProps = {
    toggle: boolean;
    setToggle: (data: boolean) => void;
    finalUserList: DropDownOptionType[];
    finalManagerList: DropDownOptionType[];
    fetching: boolean;
    limit: number;
    setOffset: React.Dispatch<React.SetStateAction<number>>;
    setText: (e: string) => void;
    managerFetching: boolean;
    managerLimit: number;
    filterStatus: string;
    filterStartDate: string;
    filterEndDate: string;
    multiSelectData: number[]|string[] | [];
    setManagerText: (e: string) => void;
    handleApplyFilter: (data: any) => void;
    handleFilterClear: () => void;
    setManagerOffset: React.Dispatch<React.SetStateAction<number>>;
    setStatus: React.Dispatch<React.SetStateAction<string>>;
    setFilterStartDate: React.Dispatch<React.SetStateAction<string>>;
    setFilterEndDate: React.Dispatch<React.SetStateAction<string>>;
    managerId: DropDownOptionType;
    responsibleId: DropDownOptionType;
    setManagerId: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
    setResponsibleId: React.Dispatch<React.SetStateAction<DropDownOptionType>>;
    showJobClosureRequest:boolean;
    handleChangeStatus:()=>void;
    setShowJobClosureRequest:React.Dispatch<React.SetStateAction<boolean>>;
    setShowJobClosureApplied:React.Dispatch<React.SetStateAction<boolean>>;
}
const JobsFilter = ({
    toggle,
    managerId,
    responsibleId,
    setManagerId,
    setResponsibleId,
    setToggle,
    setFilterEndDate,
    setFilterStartDate,
    setStatus,
    finalManagerList,
    finalUserList,
    setText,
    setManagerOffset,
    managerLimit,
    setOffset,
    fetching,
    managerFetching,
    limit,
    setManagerText,
    handleApplyFilter,
    handleFilterClear,
    filterStatus,
    filterStartDate,
    filterEndDate,
    multiSelectData,
    showJobClosureRequest,
    handleChangeStatus,
    setShowJobClosureRequest,
    setShowJobClosureApplied
}: AppProps) => {


const filterCount: number = Object.values(multiSelectData)?.filter((e: any) =>
    (e === true) || 
    (typeof e === "string" && e.trim().length > 0) || 
    (typeof e === "object" && e?.hasOwnProperty("value") && e?.value !== "") 
  )?.length;
  
  
    const handleManagerDetailsChange = (data: any) => {
        setManagerId(data)
    }
    const handleResponsibleDetailsChange = (data: any) => {
        setResponsibleId(data)
    }
    const filterEndDateChange = (date: any) => {
        if (date !== "Invalid date") {
            setFilterEndDate(date)
        }
        else {
            setFilterEndDate("")
        }
    }
    const filterStartDateChange = (date: any) => {
        if (date !== "Invalid date") {
            setFilterStartDate(date)
        }
        else {
            setFilterStartDate("")
        }
    }
    const handleRadioValue = (data: any) => {
        setStatus(data)
    }


    const checkBottom = () => {
        setOffset((prv: number) => prv + limit);
    };

    const checkManagerBottom = () => {
        setManagerOffset((prv: number) => prv + managerLimit);
    };

    const handleApplyFilterData = () => {
        setShowJobClosureApplied(true)
        const finalData = {
            filterStatus,
            filterStartDate,
            filterEndDate,
            managerId: managerId,
            responsibleId: responsibleId,
            showJobClosureRequest
        }
        handleApplyFilter(finalData)
    }

    const clearFilter = () => {
        setStatus("")
        setFilterEndDate("")
        setFilterStartDate("")
        setManagerId({
            value: null,
            label: "Select.."
        })
        setResponsibleId({
            value: null,
            label: "Select.."
        })
        setShowJobClosureRequest(false)
        setShowJobClosureApplied(false)
        handleFilterClear()
    }

    const resetFilter=()=>{
        setStatus("")
        setFilterEndDate("")
        setFilterStartDate("")
        setManagerId({
            value: null,
            label: "Select.."
        })
        setResponsibleId({
            value: null,
            label: "Select.."
        }) 
        setShowJobClosureRequest(false)
    }

    const empty=()=>{
    
    const {  filterStatus,filterStartDate,filterEndDate,managerId,responsibleId, showJobClosureRequest}:any=multiSelectData;
    filterStartDateChange(filterStartDate)
    filterEndDateChange(filterEndDate)
    setResponsibleId(responsibleId)
    setStatus(filterStatus)
    setManagerId(managerId)
    setShowJobClosureRequest(showJobClosureRequest)
    }

    const Option = (props: any) => {
        const { data } = props;
        return (
            <components.Option {...props} >
                <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
                    <CircularAvatar name={data?.label.split("%")[0]} image={data?.image && data?.image} />
                    <div style={{ marginTop: "-3px" }}>
                        <span style={{ fontWeight: "500", fontSize: "16px" }}>{data?.label.split("%")[0]}</span>
                        <br></br>
                        <span style={{ color: "#6e7491" }}>{data?.label.split("%")[1]}</span>
                    </div>
                </div>
            </components.Option>
        );
    };

    const dropDownStyle = {
        option: (baseStyles: any, state: any) => ({
            ...baseStyles,
            width: '100%',
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            width: '65%',
        }),
        container: (provided: any) => ({
            ...provided,
            width: "150%",
            // position: 'absolute'
        })
    }
    return (
        <ButtonDropdown
            isOpen={toggle}
            toggle={() => {
                filterCount===0&&toggle?resetFilter():empty()
                setToggle(!toggle)
            }}

        >
            <DropdownToggle
                caret
                color='#262a44'
                style={{
                    border: "1px solid #bfcbe1",
                    backgroundColor: "#ffffff",
                    height: '38px'
                }}
            >
                <img src={FilterIcon} alt="" />
                <span className={filterCount!==0?'filter-count':""}><span>{filterCount!==0?filterCount:""}</span></span>
            </DropdownToggle>
            <DropdownMenu right style={{ width: "400px", padding: '15px 25px 30px' }}>
                <div className='d-flex justify-content-between mt-0 mb-0'>
                    <h5 className='text-center '>Filter</h5>
                    <div className='pointer' onClick={() => {
                        setToggle(!toggle)
                        // setClearFilter(false)
                    }}>
                        <img src={CloseIcon} alt="" />
                    </div>

                </div>
                <hr className='mt-0 mb-2' />

                <div className="row mt-3">
                    <div className='d-flex'>
                        <div className="form-group col-md-6">
                            <div className='date-picker-wraper mr-0 position-relative'>
                                <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}>Target Start Date
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={filterStartDate ? new Date(moment(`${filterStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(e: any) => { filterStartDateChange(moment(e).format('YYYY-MM-DD')) }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    // onInputClick={()=>setText(choosefilterStartDate)}
                                    name='filterStartDate'
                                    placeholderText="Select"
                                    className='form-control'

                                />
                                <span className="calender-icon" style={{ top: "28px", right: '4px', cursor: 'pointer', position: "absolute" }}>
                                    <CalenderIcon />
                                </span>
                                </Label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <div className='date-picker-wraper mr-0'>
                                    <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}>Target End Date
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={filterEndDate ? new Date(moment(`${filterEndDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                        onChange={(e: any) => { filterEndDateChange(moment(e).format('YYYY-MM-DD')) }}
                                        fixedHeight
                                        showMonthDropdown
                                        showYearDropdown
                                        name='filterEndDate'
                                        placeholderText='Select'
                                        className='form-control'
                                        // disabled={!choosefilterStartDate}
                                        minDate={filterStartDate ? new Date(moment(`${filterStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    />
                                    <span className="calender-icon" style={{ top: "28px", right: '20px', cursor: 'pointer' }}>
                                        <CalenderIcon />
                                        </span>
                                        </Label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row d-flex'>
                    <div className='col-md-6'>
                        <Label className='mb-1' style={{ fontSize: "14px" }}>Currently Responsible</Label>
                        <Select
                            // className={`${item?.managerError?"error-border rounded":""}`}
                            styles={dropDownStyle}
                            options={finalUserList}
                            value={responsibleId}
                            components={{ Option }}
                            onChange={(e) => handleResponsibleDetailsChange(e)}
                            isSearchable={true}
                            isLoading={fetching}
                            onMenuClose={() => { setOffset(0) }}
                            onMenuScrollToBottom={checkBottom}
                            onInputChange={(e) => {
                                setText(e)
                            }}
                            placeholder="Select"
                        />
                        {/* {item?.managerError && (
                                    <small className='text-danger' style={{ position: "absolute", top: "40px", fontSize: "12px", left: "5px" }}>{item?.managerError ? item?.managerError : ""}</small>
                                )} */}
                    </div>
                    <div className='col-md-6'>
                        <Label className='mb-1' style={{ fontSize: "14px" }}>Job Manager</Label>
                        <Select
                            // className={`${item?.responsibleError?"error-border rounded":""}`}
                            styles={dropDownStyle}
                            options={finalManagerList}
                            value={managerId}
                            components={{ Option }}
                            onChange={(e) => handleManagerDetailsChange(e)}
                            isSearchable={true}
                            isLoading={managerFetching}
                            onMenuClose={() => { setManagerOffset(0) }}
                            onMenuScrollToBottom={checkManagerBottom}
                            onInputChange={(e) => {
                                setManagerText(e)
                            }}
                        />
                        {/* {item?.responsibleError && (
                                    <small className='text-danger' style={{ position: "absolute", top: "40px", fontSize: "12px", left: "5px" }}>{item?.responsibleError ? item?.responsibleError : ""}</small>
                                )} */}
                    </div>
                </div>
                <div className='row d-block p-3'>
                    <div>
                        <label style={{ fontSize: "14px" }}>Status</label>
                    </div>
                    <div className='mt-2'>
                        <RadioContainer
                            optionsList={RADIO_OPTIONS}
                            handleSetRadioValue={handleRadioValue}
                            radioValue={filterStatus}
                        // alignment="vertical"
                        />
                    </div>
                </div>
                 <div>
        <label htmlFor="Stage" className="royaltyLabel ms-3">
          Show Job Closure Requests
        </label>
        <div className="questions-toggle pt-1 ms-3">
          <div className="toggleFilterMainDiv">
            <div className="toggleFilterInnerDiv">
              <ToggleSwitch
                handleToggleChange={() => handleChangeStatus()}
                isChecked={showJobClosureRequest}
                name="dailyVoucherFilter"
              />
             
              <span className="mt-1 toogleTextLabel">
                {}
    </span>
            </div>
          </div>
        </div>
      </div>
                <div className='d-flex align-items-center justify-content-end mt-3'>
                    <button className='mr-2 btn btn-outline' onClick={() => {
                        clearFilter()
                        setToggle(!toggle)
                    }
                    }>Clear Filter</button>
                    <button className='btn btn-primary' onClick={() => {
                        handleApplyFilterData()
                        setToggle(!toggle)
                    }}>Apply</button>
                </div>
                {/* <button id='current' className="btn btn-outline-secondary col-md-12 mb-2" onClick={() => handleCurrentYear()} style={{color:text==="Current Financial Year"?'red':"",borderColor:text==="Current Financial Year"?'red':""}}>Current FY</button> */}
                {/* <button id='previous' className="btn btn-outline-secondary col-md-12" onClick={() => handlePreviousYear()} style={{color:text==="Previous Financial Year"?'red':"",borderColor:text==="Previous Financial Year"?'red':""}}>Previous FY</button> */}
            </DropdownMenu>
        </ButtonDropdown>
    )
}

export default JobsFilter